import { render, staticRenderFns } from "./fichajes.vue?vue&type=template&id=a97994bc&scoped=true"
import script from "./fichajes.vue?vue&type=script&lang=js"
export * from "./fichajes.vue?vue&type=script&lang=js"
import style0 from "./fichajes.vue?vue&type=style&index=0&id=a97994bc&prod&scoped=true&lang=css"
import style1 from "./fichajes.vue?vue&type=style&index=1&id=a97994bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97994bc",
  null
  
)

export default component.exports